import React from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography,
  Avatar
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { BASE_NAME } from "../../routes";
 
const Modal = ({open, handleOpen, member})  => {

  const { t } = useTranslation('global');
  const translationPrefix = 'About'

  const pubs = [1, 2, 3, 4, 5, 6];
 
  return (
    <Dialog className="w-2/3" open={open} handler={handleOpen}>
      {
        member !== '' ? (
        <>
        <DialogHeader className="justify-between p-8">
          <div className="flex row items-center">
            <Avatar
              size="sm"
              variant="circular"
              alt="..."
              className="w-16 h-16"
              src={`${BASE_NAME}/img/${t(`${translationPrefix}.${member}.img`)}`}
            />
            <div className="-mt-px flex flex-col ml-4">
              <Typography
                color="blue-gray"
                className="text-md font-semibold"
              >
                {member ? t(`${translationPrefix}.${member}.name`) : ''}
              </Typography>
              <Typography
                color="gray"
                className="text-sm font-semibold"
              >
                {member ? t(`${translationPrefix}.${member}.job`) : ''}
              </Typography>
            </div>
          </div>
        </DialogHeader>
        <DialogBody className="px-8 pt-0">
          <h3 className="text-lg font-medium blueGray mb-2">
            {t(`${translationPrefix}.papers`)}:
          </h3>
          <ul className="mx-8 list-disc">
              {
                  pubs.map((pub) => {
                      if ( member && t(`${translationPrefix}.${member}.pubs.pub${pub}.name`) !== '') {
                          return (
                              <li key={`${member}-pub${pub}`}> 
                                  <a 
                                    className="flex font-normal text-blueGray-600 underline"
                                    href={member && t(`${translationPrefix}.${member}.pubs.pub${pub}.link`)} 
                                    target="_blank" 
                                    rel="noopener noreferrer">
                                      { member && t(`${translationPrefix}.${member}.pubs.pub${pub}.name`)}
                                  </a>
                              </li>
                          )
                      } else {
                        return(<></>)
                      }
                  })                        
              }
          </ul>
        </DialogBody>
        <DialogFooter className="flex items-center justify-center">
          <button onClick={handleOpen} className="bg-blueGray-700 text-white font-bold px-8 py-3 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-400 active:bg-blueGray-500 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150">
            {t(`${translationPrefix}.close`)}
          </button>
      </DialogFooter>
      </>
      ) : (
        <></>
      )
    }
    </Dialog>
  );
}
export default Modal;